module.exports = __webpack_public_path__ + "img/shape-7-gold@2x.a903d753.png";